export function evidenceExtractReadiness(doc) {
    if (doc.extractUsable)
        return "usable";
    if (doc.extractionStatus === "failed")
        return "failed";
    if (doc.extractionStatus === "pending" || doc.extractionStatus === "processing") {
        return "pending";
    }
    return "unusable";
}
export function evidenceExtractReadinessCopy(state) {
    switch (state) {
        case "usable":
            return "";
        case "pending":
            return "Extract not ready.";
        case "failed":
            return "Extract failed.";
        case "unusable":
            return "Attached, but no usable text (scan or empty file). OCR is not available.";
    }
}
//# sourceMappingURL=evidence-extract-readiness.js.map